import TableTemplete from "../Helper/TableTemplet/TableTemplet";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getFeeAuditors,
  updateDimensionInDB,
  updateDimensionsByExcel,
  uploadDangerousGoodsByExcel,
} from "./FeeAuditorsUtils";
import { exportToExcel } from "../Helper/Excel/Excel";
import UploadFileBtn from "../Helper/UploadFileBtn/UploadFileBtn";
import userRoles from "../../configs/userRolesConfigs";
import { Box, Button } from "@mui/material";


const columns = [
  {
    id: "product_image", label: "",
    //  minWidth: 80,
    edit: false, type: "image"
  },
  {
    id: "title", label: "Title",
    // minWidth: 320,
    edit: false, type: "text"
  },
  {
    id: "dimensions",
    label: "Dimentions",
    // minWidth: 500,
    align: "right",
    edit: true,
    type: "table",
    subColumns: [
      { id: "title", label: "", edit: false, type: "text" },
      { id: "length", label: "Length", edit: true, type: "number" },
      { id: "width", label: "Width", edit: true, type: "number" },
      { id: "height", label: "Height", edit: true, type: "number" },
      {
        id: "unit_of_dimension",
        label: "Unit",
        edit: false,
        type: "text",
      },
      { id: "weight", label: "Weight", edit: true, type: "number" },
      { id: "unit_of_weight", label: "Weight unit", edit: false, type: "text" },
      { id: "fees", label: "Fees", edit: true, type: "number" },
    ],
  },
  {
    id: "money_lost",
    label: "Money Lost",
    // minWidth: 170,
    align: "right",
    edit: false,
    isNum: true,
    format: (value) => value.toLocaleString(),
    type: "number",
  },
  {
    id: "unit_sold",
    label: "Unit Sold",
    // minWidth: 80,
    align: "right",
    edit: false,
    isNum: true,
    format: (value) => value.toLocaleString(),
    type: "number",
  },
];

const FeeAuditors = () => {
  const dispatch = useDispatch();

  let defaultAccount = useSelector(
    (state: any) => state.account.default_account
  );

  let userRol = useSelector((state: any) => state.general.userRol);

  useEffect(() => {
    if (defaultAccount && defaultAccount.id)
      getFeeAuditors(dispatch, defaultAccount.id);
  }, [defaultAccount]);

  const feeAuditorsList = useSelector(
    (state: any) => state.feeAuditors.fee_auditors_cases
  );

  const saveChangesInDB = (feeAuditors) => {
    updateDimensionInDB(dispatch, feeAuditors.dimensions[1], defaultAccount.id);
  };

  const importDimensionsExcel = async (file) => {
    const res = await updateDimensionsByExcel(
      dispatch,
      file,
      defaultAccount.id
    );
    handleResponseImportExcel(res);
  };

  const importDangerousGoodsExcel = async (file) => {
    const res = await uploadDangerousGoodsByExcel(
      dispatch,
      file,
      defaultAccount.id
    );
    handleResponseImportExcel(res);
  };

  const handleResponseImportExcel = (response) => {
    const message = response["message"];
    if (message === "success") {
      alert("success");
    } else if (message === "account_id required") {
      alert("Account ID is Requierd!");
    } else if (message === "no_data") {
      alert("No data found");
    } else if (message === "invalid_params") {
      alert("Incompatible file column structure!");
    } else if (message === "invalid_account") {
      alert(
        "There are records that cannot be entered into the selected account!"
      );
    } else {
      alert("An error occurred");
    }
  };

  const exportDimensionsToExcel = () => {
    var data = feeAuditorsList
      .map((item) => {
        return { id: item.id, dimension: item.dimensions[1] };
      })
      .map((dis) => {
        return {
          id: dis.id,
          fnsku: dis.dimension.fnsku,
          Length: dis.dimension.length,
          Width: dis.dimension.width,
          Height: dis.dimension.height,
          Weight: dis.dimension.weight,
        };
      });
    let header = ["id", "FNSKU", "Length", "Width", "Height", "Weight"];
    exportToExcel(data, header);
  };
  return (
    <div>
      <h2>Fee Auditor</h2>
      <TableTemplete
        columns={columns}
        data={feeAuditorsList}
        saveChangesInDB={saveChangesInDB}
        key={feeAuditorsList}
      ></TableTemplete>
      {(userRol === userRoles.analyst ||
        userRol === userRoles.admin) && (
          <Box sx={{ marginTop: 3 }}>
            <Button
              disabled={feeAuditorsList.length === 0}
              className="blue-btn"
              type="submit"
              size="large"
              onClick={exportDimensionsToExcel}
            >
              Export
            </Button>
            <Box sx={{display: "flex", marginTop: 5, justifyContent: 'flex-start'}}>
              <Box>
              <UploadFileBtn
                onSubmit={importDimensionsExcel}
                multiple={false}
                fileType="excel"
                title="Import Dimensions"
                classes="small-upload-file"
                exdendStyle={true}
              ></UploadFileBtn>

              </Box>
              <Box sx={{marginLeft: 5}}>
              <UploadFileBtn
                onSubmit={importDangerousGoodsExcel}
                multiple={false}
                exdendStyle={true}
                fileType="excel"
                classes="small-upload-file"
                title="Import Dangerous Goods Report"
              ></UploadFileBtn>

              </Box>
            </Box>

          </Box>
        )}
    </div>
  );
};

export default FeeAuditors;
